import {
    DOCUMENT_CREATE_REQUEST,
    DOCUMENT_CREATE_SUCCESS,
    DOCUMENT_CREATE_FAIL,
    DOCUMENTS_LIST_REQUEST,
    DOCUMENTS_LIST_SUCCESS,
    DOCUMENTS_LIST_FAIL,
    GET_DOCUMENT_REQUEST,
    GET_DOCUMENT_SUCCESS,
    GET_DOCUMENT_FAIL,
    DELETE_DOCUMENT_REQUEST,
    DELETE_DOCUMENT_SUCCESS,
    DELETE_DOCUMENT_FAIL
} from '../constants/documentConstant'
import documentServices from '../services/documentsServices'

const getError = error => error.response && error.response.data
    ? error.response.data.error
    : error.message

export const createDocument = (document) => async(dispatch) => {
    dispatch({type:DOCUMENT_CREATE_REQUEST})
    try {
        const {data} = await documentServices.create(document)
        dispatch({type:DOCUMENT_CREATE_SUCCESS, payload:data.message})
    } catch (error) {
        dispatch({type:DOCUMENT_CREATE_FAIL, payload:getError(error)})
    }
}

export const listAllDocuments = (sort) => async(dispatch) => {
    dispatch({type:DOCUMENTS_LIST_REQUEST})
    try {
        const {data} = await documentServices.index(sort)
        dispatch({
            type:DOCUMENTS_LIST_SUCCESS,
            payload:data.documents,
            count:data.documentsCounts,
            page:data.page
        })
    } catch (error) {
        dispatch({type:DOCUMENTS_LIST_FAIL, payload:getError(error)})
    }
}

export const getOneDocument = (id) => async(dispatch) => {
    dispatch({type:GET_DOCUMENT_REQUEST})
    try {
        const {data} = await documentServices.document(id)
        dispatch({type:GET_DOCUMENT_SUCCESS, payload:data.document})
    } catch (error) {
        dispatch({type:GET_DOCUMENT_FAIL, payload:getError(error)})
    }
}

export const deleteDocument = (id) => async(dispatch) => {
    dispatch({type:DELETE_DOCUMENT_REQUEST})
    try {
        const {data} = await documentServices.delete(id)
        dispatch({type:DELETE_DOCUMENT_SUCCESS, payload:data.message})
    } catch (error) {
        dispatch({type:DELETE_DOCUMENT_FAIL, payload:getError(error)})
    }
}
